import { render } from "./museumHome.vue?vue&type=template&id=1294a0cc"
import script from "./museumHome.vue?vue&type=script&lang=js"
export * from "./museumHome.vue?vue&type=script&lang=js"

import "./museumHome.vue?vue&type=style&index=0&id=1294a0cc&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__